import type { UserMarketplaceResponseDTO } from '@sellsen/generated-sources';

/**
 * Derin bağlantıdan gelen pazar (`?marketplace=UNITED_STATES`). Yeni sekmede "seçili pazar"
 * yoktur; eklentinin Seller Central rozeti bu parametreyi ekler ki sipariş detayı pazar seçim
 * sayfasına düşmeden açılsın. Yalnız kullanıcının kendi pazarlarından biri kabul edilir.
 */
export function resolveMarketplaceParam(
  raw: string | null | undefined,
  userMarketplaces: UserMarketplaceResponseDTO[] | undefined
): string | undefined {
  const wanted = String(raw || '')
    .trim()
    .toUpperCase();
  if (!wanted || !userMarketplaces?.length) return undefined;
  const match = userMarketplaces.find(
    (um) => String(um.marketplaceDTO?.marketplace || '').toUpperCase() === wanted
  );
  return match?.marketplaceDTO?.marketplace || undefined;
}
